module.exports = __webpack_public_path__ + "static/img/hr.470142fe.png";